import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Clock = ({ fill: fillProp, style }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M21.2493 28.3332C18.0855 28.3332 15.4056 27.2353 13.2098 25.0394C11.0139 22.8436 9.91602 20.1637 9.91602 16.9998C9.91602 13.8359 11.0139 11.1561 13.2098 8.96025C15.4056 6.76442 18.0855 5.6665 21.2493 5.6665C24.4132 5.6665 27.0931 6.76442 29.2889 8.96025C31.4848 11.1561 32.5827 13.8359 32.5827 16.9998C32.5827 20.1637 31.4848 22.8436 29.2889 25.0394C27.0931 27.2353 24.4132 28.3332 21.2493 28.3332ZM10.4118 27.9082C7.74379 27.5776 5.57747 26.3557 3.91289 24.2425C2.24831 22.1294 1.41602 19.7151 1.41602 16.9998C1.41602 14.2846 2.24831 11.8703 3.91289 9.75713C5.57747 7.64393 7.74379 6.42206 10.4118 6.0915V8.14567C8.33407 8.52345 6.66949 9.55643 5.4181 11.2446C4.16671 12.9328 3.54102 14.8512 3.54102 16.9998C3.54102 19.1484 4.16671 21.0669 5.4181 22.755C6.66949 24.4432 8.33407 25.4762 10.4118 25.854V27.9082ZM21.2493 26.2082C23.7757 26.2082 25.9421 25.305 27.7483 23.4988C29.5546 21.6925 30.4577 19.5262 30.4577 16.9998C30.4577 14.4734 29.5546 12.3071 27.7483 10.5009C25.9421 8.69463 23.7757 7.7915 21.2493 7.7915C18.723 7.7915 16.5566 8.69463 14.7504 10.5009C12.9441 12.3071 12.041 14.4734 12.041 16.9998C12.041 19.5262 12.9441 21.6925 14.7504 23.4988C16.5566 25.305 18.723 26.2082 21.2493 26.2082Z"
        fill={fill}
      />
      <path
        d="M25.4144 22.4687L26.6894 21.1937L22.1844 16.6603V10.9653H20.4844V17.3403L25.4144 22.4687Z"
        fill={fill}
      />
    </svg>
  );
};
